import colors from '../../theme/foundations/colors'
import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'
import sizes from '../../theme/foundations/sizes'

export const cartBannerStyle = {
    '.banner': {
        marginTop: [pxToRem(0), pxToRem(0), pxToRem(40), pxToRem(40)],
        marginBottom: [pxToRem(30), pxToRem(30), pxToRem(30), pxToRem(30)],
        backgroundColor: 'cav_red',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        img: {
            marginTop: [pxToRem(63), pxToRem(63), pxToRem(43), pxToRem(43)],
            width: [pxToRem(175), pxToRem(175), pxToRem(220), pxToRem(220)],
            height: [pxToRem(39.6), pxToRem(39.6), pxToRem(50), pxToRem(50)]
        },
        h2: {
            marginTop: [pxToRem(35), pxToRem(35), pxToRem(20), pxToRem(20)],
            marginBottom: '0px',
            color: 'white',
            textAlign: 'center',
            fontFamily: fonts.primary,
            fontSize: [pxToRem(16), pxToRem(16), pxToRem(18), pxToRem(18)],
            fontWeight: '500',
            lineHeight: 'normal',
            letterSpacing: [pxToRem(2), pxToRem(2), pxToRem(3), pxToRem(3)],
            textTransform: 'uppercase'
        },
        p: {
            marginTop: [pxToRem(15), pxToRem(15), pxToRem(20), pxToRem(20)],
            marginBottom: '0px',
            color: 'white',
            textAlign: 'center',
            fontFamily: fonts.primary,
            fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
            fontWeight: '400',
            lineHeight: 'normal',
            letterSpacing: pxToRem(1)
        }
    },
    '.content-button': {
        marginTop: [pxToRem(40), pxToRem(40), pxToRem(34), pxToRem(34)],
        marginBottom: [pxToRem(63.39), pxToRem(63.39), pxToRem(47), pxToRem(47)],
        display: 'grid',
        gap: [pxToRem(15), pxToRem(15), pxToRem(20), pxToRem(20)],
        justifyContent: 'center',
        a: {
            width: [pxToRem(260), pxToRem(260), pxToRem(295), pxToRem(295)],
            height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
            padding: `${pxToRem(12)} ${pxToRem(20)}`,
            justifyContent: 'center',
            alignItems: 'center',
            background: 'white',
            color: 'cav_red',
            textAlign: 'center',
            fontFamily: fonts.primary,
            fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
            fontWeight: '700',
            lineHeight: pxToRem(13.5),
            letterSpacing: pxToRem(1.5),
            textTransform: 'uppercase',
            '&:hover': {
                background: 'cav_red',
                color: 'white',
                border: `${pxToRem(1)} solid ${colors.white}`
            }
        }
    }
}

export const containerStyle = {
    width: {
        base: pxToRem(61),
        sm: pxToRem(61),
        md: pxToRem(72)
    },
    height: pxToRem(40),
    flexDirection: 'row',
    alignItems: 'center',
    border: '1px solid black',
    overflow: 'hidden',
    margin: 0,
    [`@media (max-width: ${sizes.container.md})`]: {
        height: pxToRem(35)
    }
}

export const buttonStyle = {
    color: 'black',
    bg: 'white',
    border: 'none',
    minW: 0,
    p: 0,
    _hover: {
        bg: 'white'
    },
    _active: {
        bg: 'white'
    },
    _focus: {
        boxShadow: 'none'
    },
    _disabled: {
        bg: 'white',
        color: 'gray.600',
        cursor: 'not-allowed'
    }
}

export const minusButtonStyle = {
    ...buttonStyle,
    w: {
        base: pxToRem(20),
        md: pxToRem(24)
    },
    h: '100%'
}

export const plusButtonStyle = {
    ...buttonStyle,
    w: {
        base: pxToRem(20),
        md: pxToRem(24)
    },
    h: '100%'
}

export const iconStyle = {
    color: 'currentColor',
    stroke: 'currentColor',
    strokeWidth: '2px',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    fill: 'none',
    w: {
        base: pxToRem(8),
        md: pxToRem(9)
    },
    h: {
        base: pxToRem(8),
        md: pxToRem(9)
    }
}

export const inputStyle = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    h: '100%',
    fontSize: pxToRem(14),
    p: 0,
    border: 'none',
    outline: 'none',
    focusBorderColor: 'transparent',
    _focus: {
        boxShadow: 'none'
    },
    fontFamily: fonts.primary,
    fontWeight: 400
}

export const flexStyle = {
    direction: 'row',
    align: 'flex-start',
    width: '100%',
    justify: {
        base: 'space-between',
        md: 'flex-start'
    },
    gap: 2
}

export const hStackStyle = {
    flex: '1',
    minW: 0,
    align: 'flex-start',
    alignItems: 'flex-start'
}

export const tagIconStyle = {
    w: pxToRem(16.17),
    h: pxToRem(16.17),
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    flex: 'none',
    mt: pxToRem(3),
    [`@media (max-width: ${sizes.container.md})`]: {
        width: pxToRem(16.17),
        height: pxToRem(16.17)
    }
}

export const calloutBoxStyle = {
    flex: '1',
    minW: 0,
    overflowWrap: 'break-word',
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: 400,
    color: 'cav_light_input_gray',
    letterSpacing: pxToRem(1),
    lineHeight: 'normal',
    m: 0,
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(12),
        letterSpacing: pxToRem(1),
        lineHeight: 'normal'
    },
    '& a': {
        color: 'cav_light_input_gray',
        textDecoration: 'none',
        _hover: {
            color: 'red.cvs'
        }
    }
}

export const tooltipStyle = {
    bg: 'blackAlpha.650',
    color: 'white',
    borderRadius: 0,
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: 400,
    placement: 'bottom-start'
}

export const desktopDetailsStyle = {
    ml: 2,
    textTransform: 'uppercase',
    fontSize: pxToRem(12),
    fontWeight: 500,
    color: 'cav_calltoaction_darkred',
    textDecoration: 'underline',
    cursor: 'pointer',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    display: {
        base: 'none',
        md: 'inline'
    }
}

export const mobileDetailsStyle = {
    textTransform: 'uppercase',
    fontSize: pxToRem(10),
    fontWeight: 500,
    color: 'cav_calltoaction_darkred',
    textDecoration: 'underline',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    display: {
        base: 'inline',
        md: 'none'
    },
    alignSelf: 'flex-start',
    flexShrink: 0,
    m: 0,
    mt: pxToRem(0.5)
}

export const dividorStyle = {
    color: colors.blackAlpha[550]
}
